import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row gt-sm" }
const _hoisted_2 = { class: "col no-padding" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"30px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)
const _hoisted_4 = { class: "row q-pt-md" }
const _hoisted_5 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "row items-center" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 gt-sm" }, null, -1)
const _hoisted_12 = { class: "col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_13 = { class: "text-primary text-h4 q-my-md q-mx-xs" }
const _hoisted_14 = {
  key: 0,
  registered: "",
  class: "bg-negative q-pa-md text-white error-msg"
}
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "col no-padding bg-grey" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "col no-padding bg-grey" }
const _hoisted_19 = { class: "col q-mt-sm" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"30px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)
const _hoisted_21 = { class: "row q-pt-md" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "column" }
const _hoisted_24 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BigCard = _resolveComponent("BigCard")!
  const _component_GreenTitle = _resolveComponent("GreenTitle")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_MainContent = _resolveComponent("MainContent")!

  return (_openBlock(), _createBlock(_component_MainContent, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_BigCard, {
            title: _ctx.$t('Login.PresentationSection.Title'),
            desc: _ctx.$t('Login.PresentationSection.Resume'),
            url: "product-intrafix.jpg"
          }, null, 8, ["title", "desc"])
        ])
      ]),
      _hoisted_3,
      _createVNode(_component_GreenTitle, {
        title: _ctx.$t('Login.LoginSection.Title')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("Login.LoginSection.P1")), 1)
            ]),
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("Login.LoginSection.P2")), 1),
              _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.$t("Login.LoginSection.P3")), 1),
              _createElementVNode("li", _hoisted_10, _toDisplayString(_ctx.$t("Login.LoginSection.P4")), 1)
            ])
          ])
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.headerTitle), 1),
          _createVNode(_component_q_separator, { class: "bg-lightgrey q-mb-lg" }),
          _createElementVNode("div", null, [
            (_ctx.errorMsg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.errorMsg), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("Login.LoginSection.NewPassword")), 1),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_q_input, {
                dense: "",
                borderless: "",
                type: "password",
                modelValue: _ctx.newPassword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event)),
                debounce: "500",
                color: "green",
                class: "col no-padding"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("Login.LoginSection.ConfirmNewPassword")), 1),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_q_input, {
                dense: "",
                borderless: "",
                type: "password",
                modelValue: _ctx.newPasswordBis,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPasswordBis) = $event)),
                debounce: "500",
                color: "green",
                class: "col no-padding",
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.tryResetPassword()), ["enter"]))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_q_btn, {
                type: "submit",
                style: {"width":"100%"},
                class: "bg-secondary text-white",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tryResetPassword()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Login.LoginSection.NewPassword")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _hoisted_20,
      _createVNode(_component_GreenTitle, {
        title: _ctx.$t('Disclaimer.Title')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", {
              class: "col",
              innerHTML: _ctx.$t('Disclaimer.Text')
            }, null, 8, _hoisted_24)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}